/*
 * Menu drawer behaviour (snippets/mobile-menu.liquid), modelled on the Shopify Dawn drawer:
 * - closes on overlay click, the close button and Escape
 * - moves focus into the drawer on open, keeps Tab inside it, and returns focus to the burger on close
 * - keeps aria-expanded on the burger in sync
 * Opening is still handled by theme.js (.js-mobile-menu-icon adds .header-navigation--open);
 * closing goes through the theme's own .js-close-mobile-menu handler so its state stays in sync.
 */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init(root) {
    var nav = root.querySelector('.header-navigation');
    var drawer = nav && nav.querySelector('#mobileMenu');
    if (!drawer || drawer.dataset.drawerReady) return;
    drawer.dataset.drawerReady = 'true';

    var overlay = nav.querySelector('[data-mobile-menu-overlay]');
    var closeButton = drawer.querySelector('[data-mobile-menu-close]');
    var themeClose = document.querySelector('.js-close-mobile-menu');
    var burgers = document.querySelectorAll('.js-mobile-menu-icon');

    burgers.forEach(function (burger) {
      burger.setAttribute('aria-controls', drawer.id);
      burger.setAttribute('aria-expanded', 'false');
    });

    function isOpen() {
      return nav.classList.contains('header-navigation--open');
    }

    function close() {
      // theme.js also binds `.close svg`, which may already have removed the nav class; the body lock can remain
      if (!isOpen() && !document.body.classList.contains('mobile-menu-open')) return;
      if (themeClose) {
        themeClose.click();
      } else {
        nav.classList.remove('header-navigation--open');
        document.body.classList.remove('mobile-menu-open');
      }
    }

    function visibleBurger() {
      for (var i = 0; i < burgers.length; i++) {
        if (burgers[i].offsetParent !== null) return burgers[i];
      }
      return burgers[0];
    }

    /*
     * Desktop: the site header stays visible (white) while the menu is open, like outfitters.com.pk.
     * Line the drawer's top bar up with the header row (X over the burger, logo over the logo) and start
     * the overlay below the header. Positions differ per page/header group, so measure them.
     */
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var MEASURED_VARS = [
      '--mobile-menu-header-bottom',
      '--mobile-menu-row-top',
      '--mobile-menu-row-height',
      '--mobile-menu-close-left',
      '--mobile-menu-logo-gap',
      '--mobile-menu-logo-width',
      '--mobile-menu-logo-left'
    ];

    function firstVisible(selector) {
      var items = document.querySelectorAll(selector);
      for (var i = 0; i < items.length; i++) {
        if (items[i].offsetParent !== null && items[i].getBoundingClientRect().width > 0) return items[i];
      }
      return null;
    }

    function syncWithHeader() {
      if (!desktopQuery.matches || !isOpen()) {
        MEASURED_VARS.forEach(function (name) {
          nav.style.removeProperty(name);
        });
        return;
      }

      var header = document.querySelector('.site-header .header-content');
      var burger = firstVisible('.site-header .js-mobile-menu-icon');
      var logo = firstVisible('.site-header .store-logo');
      var row = burger && burger.closest('.utils');
      if (!header || !burger || !row) return;

      // Read everything first, then write
      var headerRect = header.getBoundingClientRect();
      var rowRect = row.getBoundingClientRect();
      var burgerRect = burger.getBoundingClientRect();
      var logoRect = logo ? logo.getBoundingClientRect() : null;
      var closeWidth = closeButton ? closeButton.getBoundingClientRect().width : 28;

      var closeLeft = burgerRect.left + burgerRect.width / 2 - closeWidth / 2;
      var values = {
        '--mobile-menu-header-bottom': Math.max(0, headerRect.bottom),
        '--mobile-menu-row-top': Math.max(0, rowRect.top),
        '--mobile-menu-row-height': rowRect.height,
        '--mobile-menu-close-left': Math.max(0, closeLeft)
      };
      if (logoRect) {
        values['--mobile-menu-logo-gap'] = Math.max(0, logoRect.left - (closeLeft + closeWidth));
        values['--mobile-menu-logo-width'] = logoRect.width;
        values['--mobile-menu-logo-left'] = logoRect.left; // links line up with the logo, as on outfitters.com.pk
      }

      Object.keys(values).forEach(function (name) {
        nav.style.setProperty(name, Math.round(values[name]) + 'px');
      });
    }

    window.addEventListener('resize', function () {
      if (isOpen()) syncWithHeader();
    });

    function onOpenChange() {
      var open = isOpen();
      burgers.forEach(function (burger) {
        burger.setAttribute('aria-expanded', String(open));
      });

      syncWithHeader();

      if (open) {
        if (closeButton) closeButton.focus({ preventScroll: true });
      } else if (drawer.contains(document.activeElement)) {
        var burger = visibleBurger();
        if (burger) burger.focus({ preventScroll: true });
      }
    }

    new MutationObserver(onOpenChange).observe(nav, { attributes: true, attributeFilter: ['class'] });

    if (overlay) overlay.addEventListener('click', close);
    if (closeButton) closeButton.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      // Keep focus inside the drawer while it is open
      var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (!drawer.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
